
export interface ProjectSection {
    title: string;
    content: string;
}
export const Content = ({ sections }: { sections: ProjectSection[] }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                color: 'var(--color-text)',
            }}
        >
            {sections.map((section, index) => {

                return (
                    <div key={index}>
                        <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                            {section.title}
                        </p>
                        <p>{section.content}</p>
                    </div>
                );
            })}
        </div>
    );
};